import Report, { ReportFormProps } from 'common/pages/report/Container.tsx'

export const ReportFormAdvertiser = (props: ReportFormProps) => <Report {...props} />
